// extracted by mini-css-extract-plugin
module.exports = {"Label":"css-modules_Label__MOzCc","Input":"css-modules_Input__RCkW3"};